import { useParams } from 'react-router-dom';

export function useParamId() {
  let { id } = useParams();
  return id ? parseInt(id) : null;
}
